'use client';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useFormControlContext } from "./chunk-DFWC5MHP.mjs"; // src/form-error.tsx

import { Icon } from "@chakra-ui/icon";
import { createContext } from "@chakra-ui/react-context";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { jsx } from "react/jsx-runtime";

var _createContext = createContext({
  name: "FormErrorStylesContext",
  errorMessage: "useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<FormError />\" "
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    FormErrorStylesProvider = _createContext2[0],
    useFormErrorStyles = _createContext2[1];

var FormErrorMessage = forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig("FormError", props);
  var ownProps = omitThemingProps(props);
  var field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid)) return null;
  return /* @__PURE__ */jsx(FormErrorStylesProvider, {
    value: styles,
    children: /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({}, field == null ? void 0 : field.getErrorMessageProps(ownProps, ref)), {}, {
      className: cx("chakra-form__error-message", props.className),
      __css: _objectSpread({
        display: "flex",
        alignItems: "center"
      }, styles.text)
    }))
  });
});
FormErrorMessage.displayName = "FormErrorMessage";
var FormErrorIcon = forwardRef(function (props, ref) {
  var styles = useFormErrorStyles();
  var field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid)) return null;

  var _className = cx("chakra-form__error-icon", props.className);

  return /* @__PURE__ */jsx(Icon, _objectSpread(_objectSpread({
    ref: ref,
    "aria-hidden": true
  }, props), {}, {
    __css: styles.icon,
    className: _className,
    children: /* @__PURE__ */jsx("path", {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    })
  }));
});
FormErrorIcon.displayName = "FormErrorIcon";
export { useFormErrorStyles, FormErrorMessage, FormErrorIcon };